import { AfterViewInit, Component, OnDestroy } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { GenericEditorEventProvider } from '../../../GenericEditorStateProvider';

@Component({
  selector: 'file-picker-modal',
  template: ` <div
    class="modal fade"
    id="fileModal"
    tabindex="-1"
    role="dialog"
  >
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h3 class="modal-title">{{ fileName }}</h3>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body" *ngIf="fileName">
          <img
            *ngIf="isImageFile"
            src="{{ fileContent }}"
            style="max-width: 100%; max-height: 40rem; display: block; margin: 0
           auto;"
          />
          <file-picker-viewer
            *ngIf="isPdfFile && fileContent"
            [pdfContent]="fileContent"
            class="file-picker-viewer"
          ></file-picker-viewer>
          <div class="preview-message text-center text-muted">
            Preview not available
          </div>
        </div>
        <div class="modal-footer">
          <a
            *ngIf="fileContent"
            [href]="pdfDownloadableContent || fileContent"
            download="{{ fileName }}"
            type="button"
            class="btn btn-primary"
          >
            Save
          </a>
          <button
            type="button"
            class="btn btn-secondary"
            (click)="closeModal()"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  </div>`,
})
export class FilePickerModalComponent implements AfterViewInit, OnDestroy {
  fileName: string; // blabla.jpg
  fileContent: string; // base64 string
  pdfDownloadableContent?: SafeResourceUrl; // fileContent with disabled sanitization

  constructor(
    public eventProvider: GenericEditorEventProvider,
    private _sanitizer: DomSanitizer
  ) {}

  get isImageFile() {
    switch (this.fileFormat) {
      case 'jpg':
      case 'jpeg':
      case 'png':
        return true;
      default:
        return false;
    }
  }

  get fileFormat() {
    return this.fileName.split('.').slice(-1)[0];
  }

  get isPdfFile() {
    switch (this.fileFormat) {
      case 'pdf':
        return true;
      default:
        return false;
    }
  }

  openModal({ fileName, fileContent, pdfDownloadableContent }) {
    $('#fileModal').modal('show');
    setTimeout(() => {
      this.fileName = fileName;
      this.fileContent = fileContent;
      this.pdfDownloadableContent = this._sanitizer.bypassSecurityTrustResourceUrl(
        fileContent
      );
    }, 100);
  }

  closeModal() {
    $('#fileModal').modal('hide');
    setTimeout(() => {
      this.fileName = null;
      this.fileContent = null;
    }, 100);
  }

  ngAfterViewInit() {
    this.eventProvider.on('OPEN_FILE_MODAL', this.openModal.bind(this));
  }

  ngOnDestroy() {
    this.closeModal();
  }
}



// WEBPACK FOOTER //
// ./app/insa-components/insa-generic-form/generic-editor/components/fields/file-picker/file-picker-modal.component.ts